import React, { memo } from 'react';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import styled, { keyframes } from 'styled-components';

const pulsate = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Lumier', sans-serif;
  margin-bottom: 10px;
  width: 100%;
`;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: #f0f0f0;
  border: 2px solid #e0e0e0;
  width: 100%;
  max-width: 1370px;
  margin-top: -40px;

  @media (max-width: 768px) {
    width: 95%;
    padding: 20px;
    margin-top: -40px;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3em;
  @media (max-width: 768px) {
    font-size: 1.1em;
  }

  a {
    color: #1e1e1e;
    text-decoration: none;
    &:hover {
      color: #1b1b1b;
      text-decoration: underline;
    }
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-right: 10px;
`;

const WhatsappIcon = styled(FontAwesomeIcon)`
  color: #25D366;
  margin-top: 10px;
  font-size: 3em;
  animation: ${pulsate} 1.5s infinite ease-in-out;
`;

const FooterRioGrande = () => {
  return (
    <Container>
      <ContactContainer>
        <ContactInfo>
          <span><strong>Escuela Net Sport Academy Rio Grande</strong><br /><br />
            <Icon icon={faPhone} />(+34) 666 18 67 72</span>
        </ContactInfo>
        <ContactInfo>
          <Icon icon={faEnvelope} />
         <a href="mailto:netsport@netsportacademy.com">netsport@netsportacademy.com</a>
        </ContactInfo>
        <ContactInfo>
          <a href="https://wa.me/34666186772" target="_blank" rel="noopener noreferrer">
            <WhatsappIcon icon={faWhatsapp} />
          </a>
        </ContactInfo>
      </ContactContainer>
    </Container>
  );
};

export default memo(FooterRioGrande);
